window.addEventListener('load', function () {
    if (document.querySelectorAll('.glossaryList .filter').length) {
        const elements = document.querySelectorAll('.glossaryList .filter');

        elements.forEach(function (element) {
            const buttons = element.querySelectorAll('button');
            const nonce = element.getAttribute('data-nonce');
            const entriesWrap = element.nextElementSibling;
            const resultsWrap = element.querySelector('.results');
            const originalHTML = entriesWrap.innerHTML; // ← speichern!
            let activeButton = null;

            function resetClasses () {
                buttons.forEach(e => e.classList.remove('active'));
            }

            if (buttons.length) {
                buttons.forEach(function (button) {
                    if (!button.classList.contains('disabled')) {
                        button.addEventListener('click', function (event) {
                            event.preventDefault();

                            if (activeButton === button) {
                                resetClasses();
                                activeButton = null;
                                entriesWrap.classList.add('loading');
                                gsap.to(entriesWrap.querySelectorAll('.entry'), {autoAlpha: 0, y: 20});

                                setTimeout(function() {
                                    entriesWrap.innerHTML = originalHTML; // ← wiederherstellen!
                                    entriesWrap.classList.remove('loading');
                                    resultsWrap.classList.add('hidden');
                                    gsap.from(entriesWrap.querySelectorAll('.entry'), {autoAlpha: 0, y: 20});
                                }, 300);
                            } else {
                                resetClasses();
                                button.classList.add('active');
                                activeButton = button;

                                const letter = button.getAttribute('data-letter');
                                const count = button.getAttribute('data-count');
                                loadGlossary(letter, nonce, entriesWrap, count, letter);
                            }
                        });
                    }
                });
            }

            function loadGlossary (letter, nonce, entriesWrap, count, displayLetter) {
                entriesWrap.classList.add('loading');
                gsap.to(entriesWrap.querySelectorAll('.entry'), {autoAlpha: 0, y: 20});

                var request = new XMLHttpRequest();
                request.open('POST', '/wp-admin/admin-ajax.php', true);
                request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
                request.onload = function () {
                    if (this.status >= 200 && this.status < 400) {
                        const response = JSON.parse(this.response);
                        entriesWrap.innerHTML = response;
                        entriesWrap.classList.remove('loading');
                        resultsWrap.classList.remove('hidden');
                        resultsWrap.textContent = count + ' Einträge zum Buchstaben ' + displayLetter;
                        gsap.from(entriesWrap.querySelectorAll('.entry'), {autoAlpha: 0, y: 20});
                    }
                };
                request.send('action=load_glossary&nonce=' + nonce + '&letter=' + letter);
            }
        });
    }
});
